
export class MenuToggle {

    constructor (button) {

        const self = this

        this.menuVisibleEvent = new Event("toggleMenu")
        this.menuVisibleEvent.detail = { showMenu: true}

        this.menuHiddenEvent = new Event("toggleMenu")
        this.menuHiddenEvent.detail = { showMenu: false}

        this.elements = document.querySelectorAll(button)
        this.elements.forEach(element => {
            element.addEventListener('click', function () {
                self.toggleButton(this)
            })
        })
    }

    toggleButton(toggleElement) {

         let openMenu = false
        
         toggleElement.classList.toggle('toggle-open')
        
         if(toggleElement.classList.contains('toggle-open')) {
             openMenu = true
         }
        
         this.elements.forEach(element => {
             if(openMenu) {
                 element.classList.add('toggle-open')
             } else {
                 element.classList.remove('toggle-open')
             }
        })

        if(openMenu) {
            document.dispatchEvent(this.menuVisibleEvent)
        } else {
             document.dispatchEvent(this.menuHiddenEvent)
        }

    }

    closeButton() {
        this.elements.forEach(element => {
            element.classList.toggle('toggle-open')
        })

        document.dispatchEvent(this.menuHiddenEvent)
    }

}
